import contact from "./contact";

export default {
  name: "Fabián",
  surnames: "Olivares Ríos",
  job: "Desarrollador Full Stack",
  description:
    "Desarrollador web especializado en Backend apuntando a FullStack, que ha participado en diferentes proyectos que involucran diversas áreas de RRHH, tales como: finanzas, asistencia, contratos, administración, desvinculaciones, entre otros.\
  Facilidad para adaptarse a los cambios de mercado e innovador con nuevas tecnologías.\
  Capacidad de trabajo en equipo, siendo muy pro-activo y autodidacta.",
  experience: new Date().getFullYear() - 2014,
  ...contact,
};
